// import React from "react";
//  import "../CourseSyllabus.css";
// import { Carousel } from 'react-responsive-carousel';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import FAQ from "./FAQ"

// const CourseSyllabus = () => {

//     const faqs = [
//         { question: "What will I learn?", answer: "Our course covers core concepts from HTML and CSS to advanced JavaScript and React. You’ll build projects and get hands-on experience with essential developer tools." },
//         { question: "Is prior experience required?", answer: "No prior experience is needed! This course is designed for beginners with step-by-step guidance." },
//         { question: "How can I track my progress?", answer: "You'll have access to interactive exercises, and we'll keep track of your achievements as you advance through the course." },
//         { question: "Will I get a certificate?", answer: "Yes! Upon completion, you’ll receive a certificate to showcase your skills." },
//       ];



//   return (
//     <div className="syllabus-container">

//     <div className="carousel-container">
//         <h2>Welcome to Your Course Journey</h2>
//       <p>Explore our syllabus on the left and get answers to your questions on the right. Our goal is to make learning fun and accessible for everyone!</p>

    


//     <Carousel  
//         autoPlay
//        // Enables the fade transition
//       dynamicHeight={false}      // Enables dynamic height based on the content's height
//       showArrows={true}        // Hides the arrows, you can toggle this as per your preference
//       infiniteLoop={true}       // Allows infinite looping of slides
//       swipeable={true}          // Enables swiping functionality
//       showThumbs={false}
//     >
//       <div>
//         <img src="/Images/Html.png" alt="HTML Fundamentals" />
//         <p className="legend">Master the building blocks of web development with HTML.</p>
//         </div>
//       <div>
//         <img src="/Images/JavaScript.png" alt="JavaScript Essentials" />
//         <p className="legend">Dive into JavaScript, the language of interactivity and logic on the web.</p>
//         </div>
//       <div>
//         <img src="/Images/React.png" alt="Intro to React" />
//         <p className="legend">Learn React, a powerful JavaScript library for building dynamic UIs.</p>
//         </div>
//       <div>
//         <img src="Images/NodeIntro.png" alt="Node Intro" />
//         <p className="legend">Get introduced to backend development with Node.js.</p>
//         </div>
//       <div>
//         <img src="/Images/FullStack.png" alt="Full Stack" />
//         <p className="legend">Combine everything to create full-stack web applications.</p>
//         </div>
//       <div>
//         <img src="/Images/Conclusion.png" alt="Conclusion" />
//         <p className="legend">Wrap up your learning journey and celebrate your achievements!</p>
//         </div>
//     </Carousel>

//   </div>

//   <FAQ faqs={faqs} />

//     </div>
//   );
// };

// export default CourseSyllabus;


import React from "react";
import "../CourseSyllabus.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import FAQ from "./FAQ";

const CourseSyllabus = () => {
  const faqs = [
    {
      question: "What will I learn?",
      answer:
        "Our course covers core concepts from HTML and CSS to advanced JavaScript and React. You’ll build projects and get hands-on experience with essential developer tools.",
    },
    {
      question: "Is prior experience required?",
      answer:
        "No prior experience is needed! This course is designed for beginners with step-by-step guidance.",
    },
    {
      question: "How can I track my progress?",
      answer:
        "You'll have access to interactive exercises, and we'll keep track of your achievements as you advance through the course.",
    },
    {
      question: "Will I get a certificate?",
      answer:
        "Yes! Upon completion, you’ll receive a certificate to showcase your skills.",
    },
  ];

  return (
    <div className="syllabus-container">
      <div className="text-content">
        <h2>Welcome to Your Course Journey</h2>
        <p>
          Explore our syllabus on the left and get answers to your questions
          on the right. Our goal is to make learning fun and accessible for
          everyone!
        </p>
      </div>

      <div className="carousel-container">
        <Carousel
          autoPlay
          dynamicHeight={false}
          showArrows={true}
          infiniteLoop={true}
          swipeable={true}
          showThumbs={false}
        >
          <div>
            <img src="/Images/Html.png" alt="HTML Fundamentals" />
            <p className="legend">Master the building blocks of web development with HTML.</p>
          </div>
          <div>
            <img src="/Images/JavaScript.png" alt="JavaScript Essentials" />
            <p className="legend">Dive into JavaScript, the language of interactivity and logic on the web.</p>
          </div>
          <div>
            <img src="/Images/React.png" alt="Intro to React" />
            <p className="legend">Learn React, a powerful JavaScript library for building dynamic UIs.</p>
          </div>
          <div>
            <img src="Images/NodeIntro.png" alt="Node Intro" />
            <p className="legend">Get introduced to backend development with Node.js.</p>
          </div>
          <div>
            <img src="/Images/FullStack.png" alt="Full Stack" />
            <p className="legend">Combine everything to create full-stack web applications.</p>
          </div>
          <div>
            <img src="/Images/Conclusion.png" alt="Conclusion" />
            <p className="legend">Wrap up your learning journey and celebrate your achievements!</p>
          </div>
        </Carousel>
      </div>

      <div className="faq-container">
        <FAQ faqs={faqs} />
      </div>
    </div>
  );
};

export default CourseSyllabus;
